var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentGenerated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_documento_generato",
    "data-name": "icona documento generato",
    transform: "translate(-768 -103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_documento_generato-2",
    "data-name": "icona documento generato",
    transform: "translate(5126.5 -16148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_166",
    "data-name": "Tracciato 166",
    d: "M14.81,21H2.75A2.692,2.692,0,0,1,0,18.375V2.625A2.692,2.692,0,0,1,2.75,0h12.5A2.692,2.692,0,0,1,18,2.625V19.31a.751.751,0,0,1-1.5,0V2.625a1.224,1.224,0,0,0-1.25-1.193H2.75A1.224,1.224,0,0,0,1.5,2.625v15.75a1.224,1.224,0,0,0,1.25,1.193H14.81a.717.717,0,1,1,0,1.432Z",
    transform: "translate(-4357 16251)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_167",
    "data-name": "Tracciato 167",
    d: "M14.25,14.932H3.75a.717.717,0,1,1,0-1.432h10.5a.717.717,0,1,1,0,1.432Z",
    transform: "translate(-4357 16250.386)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_168",
    "data-name": "Tracciato 168",
    d: "M14.25,10.932H3.75a.717.717,0,1,1,0-1.432h10.5a.717.717,0,1,1,0,1.432Z",
    transform: "translate(-4357 16250.567)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_169",
    "data-name": "Tracciato 169",
    d: "M9.25,6.932H3.75a.717.717,0,1,1,0-1.432h5.5a.717.717,0,1,1,0,1.432Z",
    transform: "translate(-4357 16250.75)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_780",
    "data-name": "Rettangolo 780",
    transform: "translate(768 103)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentGenerated);
export default __webpack_public_path__ + "static/media/document_generated.77db029bbe0936db8e8fb5620760143f.svg";
export { ForwardRef as ReactComponent };